import React, { useState } from "react";
import { X, ClipboardList, Briefcase } from "lucide-react";

export default function AddCompositionModal({ isOpen, onClose, onSelectType }) {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4 modal-backdrop-enter">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl ring-1 ring-slate-200/70 shadow-2xl w-full max-w-md flex flex-col overflow-hidden modal-panel-enter">
        <div className="px-6 py-5 border-b border-slate-100 flex justify-between items-start">
          <div>
            <h3 className="text-lg font-semibold text-slate-900 tracking-tight">
              Tambah Komposisi
            </h3>
            <p className="text-sm text-slate-500 mt-1">
              Pilih salah satu kategori komposisi dibawah
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-3">
          <button
            onClick={() => onSelectType("product")}
            className="w-full flex items-center justify-between p-4 ring-1 ring-slate-200 rounded-xl bg-white hover:ring-teal-500 hover:bg-teal-50/60 hover:shadow-sm transition-all group">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center text-white shadow-sm shadow-teal-600/20">
                <ClipboardList className="w-6 h-6" />
              </div>
              <div className="text-left">
                <h4 className="font-semibold text-slate-900 group-hover:text-teal-700">
                  Produk
                </h4>
                <p className="text-xs text-slate-500 mt-0.5">
                  Komposisi produk yang mempengaruhi stok
                </p>
              </div>
            </div>
            <div className="w-8 h-8 rounded-full bg-white ring-1 ring-slate-200 flex items-center justify-center group-hover:ring-teal-500">
              <svg
                className="w-4 h-4 text-slate-400 group-hover:text-teal-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </button>

          <button
            onClick={() => onSelectType("service")}
            className="w-full flex items-center justify-between p-4 ring-1 ring-slate-200 rounded-xl bg-white hover:ring-teal-500 hover:bg-teal-50/60 hover:shadow-sm transition-all group">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center text-white shadow-sm shadow-teal-600/20">
                <Briefcase className="w-6 h-6" />
              </div>
              <div className="text-left">
                <h4 className="font-semibold text-slate-900 group-hover:text-teal-700">
                  Jasa
                </h4>
                <p className="text-xs text-slate-500 mt-0.5">
                  Komposisi yang tidak mempengaruhi stok
                </p>
              </div>
            </div>
            <div className="w-8 h-8 rounded-full bg-white ring-1 ring-slate-200 flex items-center justify-center group-hover:ring-teal-500">
              <svg
                className="w-4 h-4 text-slate-400 group-hover:text-teal-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
